export * from './erforderliches-dokuments.page';
export * from './erforderliches-dokuments.page.resolver';
